import Box from '@mui/material/Box';
import cindyChatPane from '/public/img/ai/cindy-chat-pane.png';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { aiChatDialogOpenSessionAtom, aiChatOpenAtom } from 'recoil/atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { FC } from 'react';
import { useEmulated } from 'containers/Layout/EmulateBar';

const getBoxSx = (isEmulated) => ({
  zIndex: 1200,
  width: 390,
  height: 122,
  position: 'fixed',
  bottom: 0,
  right: isEmulated ? 70 : 0,
  background: `url(${cindyChatPane.src}) no-repeat center center`,
  backgroundSize: 'cover',
  cursor: 'pointer',
});

const ButtonSx = {
  borderRadius: 52,
  border: '1px solid #FFF',
  boxShadow:
    '0px 2px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 4px rgba(0, 0, 0, 0.12)',
  background: 'rgba(255, 255, 255, 0.2)',
  position: 'absolute',
  bottom: 15,
  right: 124,
};

const AiChatPane: FC = (): JSX.Element => {
  const [openAiChat, setOpenAiChat] = useRecoilState(aiChatOpenAtom);
  const wasOpenedThisSession = useRecoilValue(aiChatDialogOpenSessionAtom);
  const { isEmulated } = useEmulated();

  if (openAiChat || !wasOpenedThisSession) {
    return null;
  }

  return (
    <Box sx={getBoxSx(isEmulated)} onClick={() => setOpenAiChat(true)}>
      <Button
        onClick={() => setOpenAiChat(true)}
        color='primary'
        variant='outlined'
        sx={ButtonSx}
      >
        <Typography
          textTransform={'capitalize'}
          fontWeight={'600'}
          color={'#FFF'}
        >
          Let&apos;s talk!
        </Typography>
      </Button>
    </Box>
  );
};

export default AiChatPane;
